import type { SupervisorFinding, SupervisorFindingDismissReason } from '@avisoma/shared';

export type FindingButton = 'apply' | 'dismiss' | 'acknowledge' | 'revert' | 'restore';

/**
 * Spec "UI": the buttons of one finding's Actions cell. Apply needs the server's `correctable` flag
 * (entity scope, identity row key, plain field); a proposal the server cannot write gets Dismiss only.
 * Acknowledge is a dismiss of a finding with no proposal.
 */
export const findingButtonsFor = (f: Pick<SupervisorFinding, 'status' | 'hasProposal' | 'correctable'>): FindingButton[] => {
  switch (f.status) {
    case 'proposed':
      if (!f.hasProposal) return ['acknowledge'];
      return f.correctable ? ['apply', 'dismiss'] : ['dismiss'];
    case 'applied':
    case 'reapplied':
      return ['revert'];
    case 'dismissed':
      return ['restore'];
    default:
      return [];
  }
};

export const isRevertable = (status: SupervisorFinding['status']): boolean =>
  status === 'applied' || status === 'reapplied';

export const DISMISS_REASON_LABEL: Record<SupervisorFindingDismissReason, string> = {
  page_correct: 'Page shows the old value',
  proposal_wrong: 'Page shows another value',
  not_verifiable: 'Not verifiable from the page',
};

/** Menu order. Only the first two count against precision. */
export const DISMISS_REASONS: SupervisorFindingDismissReason[] = ['page_correct', 'proposal_wrong', 'not_verifiable'];

/** Catalyst `Button` `buttonClassName` that fits a dense table row (twMerge lets it win over the base padding). */
export const COMPACT_BUTTON_CLASS = 'px-2 py-0.5 text-xs/5 sm:px-2 sm:py-0.5 sm:text-xs/5';
